module.exports = __webpack_public_path__ + "static/media/caret-left.406def38.svg";